const schemaReduced = {
  id: "",
  name: "",
  sequence: ""
};

export default schemaReduced;
